const tabLinks = document.querySelectorAll('.pill-link');
const tabItems = document.querySelectorAll('.tab-item');

tabLinks.forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();
    
    // Remove active class from all tabs
    tabItems.forEach(item => item.classList.remove('active'));
    
    // Add active class to clicked tab
    this.parentElement.classList.add('active');
    
    // Get target section
    const targetId = this.getAttribute('data-tab-target');
    const targetElement = document.querySelector(targetId) || document.getElementById(targetId);
    
    if (targetElement) {
      // Smooth scroll to target
      const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offset = 120;
      
      window.scrollTo({
        top: offsetTop - offset,
        behavior: 'smooth'
      });
    }
  });
});

// Optional: Update active tab on scroll 
const sections = Array.from(tabLinks).map(link => {
  const targetId = link.getAttribute('data-tab-target');
  return document.querySelector(targetId) || document.getElementById(targetId);
}).filter(Boolean);

window.addEventListener('scroll', function() {
  const scrollPos = window.scrollY + 120 + 100;
  
  sections.forEach((section, index) => {
    const sectionTop = section.offsetTop;
    const sectionBottom = sectionTop + section.offsetHeight;
    
    if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
      tabItems.forEach(item => item.classList.remove('active'));
      if (tabItems[index]) {
        tabItems[index].classList.add('active');
      }
    }
  });
});